<template>
    <footer class="footer">
        <div class="vuoisaperne">
            <img src="@/assets/vuoisaperne-image.png" alt="">
            <h6 v-if="lang === 'it'">Vuoi saperne di più sul nostro territorio?</h6>
            <h6 v-if="lang === 'en'">Would you like to know more about our territory?</h6>
            <h6 v-if="lang === 'de'">Möchten Sie mehr über unser Gebiet erfahren?</h6>

            <a target="_blank" rel="noopener noreferrer"
                :href="lang === 'it' ? externalLink_it_attivita :
                    lang === 'en' ? externalLink_en_attivita :
                        externalLink_de_attivita
                    ">
                <img src="@/assets/icon-attivita-commerciali.svg" alt="">
                <h6 v-if="lang === 'it'">Attività commerciali</h6>
                <h6 v-if="lang === 'en'">Commercial activities</h6>
                <h6 v-if="lang === 'de'">Gewerbliche Tätigkeiten</h6>
                <img class="arrow" src="@/assets/icon-circle-arrow.svg" alt="">
            </a>


            <a target="_blank" rel="noopener noreferrer" :href="lang === 'it' ? externalLink_it_piste :
                lang === 'en' ? externalLink_en_piste :
                    externalLink_de_piste
                ">

                <img src="@/assets/icon-piste-ciclabili.svg" alt="">
                <h6 v-if="lang === 'it'">Piste ciclabili</h6>
                <h6 v-if="lang === 'en'">Cycling routes</h6>
                <h6 v-if="lang === 'de'">Fahrradrouten</h6>
                <img class="arrow" src="@/assets/icon-circle-arrow.svg" alt="">
            </a>


            <a target="_blank" rel="noopener noreferrer" :href="lang === 'it' ? externalLink_it_interessi :
                lang === 'en' ? externalLink_en_interessi :
                    externalLink_de_interessi
                ">
                <img src="@/assets/icon-punti-interesse.svg" alt="">
                <h6 v-if="lang === 'it'">Punti di interesse</h6>
                <h6 v-if="lang === 'en'">Points of interest</h6>
                <h6 v-if="lang === 'de'">Sehenswürdigkeiten</h6>
                <img class="arrow" src="@/assets/icon-circle-arrow.svg" alt="">
            </a>
        </div>

        <div class="contacts">
            <div class="container">
                <div class="policy">
                    <span v-if="lang === 'it'">Seguici su:</span>
                    <span v-if="lang === 'en'">Follow us on:</span>
                    <span v-if="lang === 'de'">Folge uns auf:</span>

                    <ul>
                        <li class="social">
                            <div>
                                <a target="_blank" class="fb" href="https://www.facebook.com/comunesancanzian/">
                                    <img src="../../assets/fb_icon-w-01.svg" width="30" alt="">
                                </a>
                                <a target="_blank" class="in"
                                    href="https://www.instagram.com/explore/locations/104808913/comune-di-san-canzian-disonzo/?hl=it">
                                    <img src="../../assets/in_icon-w-01.svg" width="30" alt="">
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="sitemap" v-if="this.footerItems">
            <div class="container">
                <div class="logo">
                    <img src="@/assets/main-logo.svg" alt="logo" height="100" width="auto" class="logo-desktop">
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'the-footer',
    data: () => {
        return {
            columnLength: 2,
            footerItems: [],
            externalLink_it_attivita: "https://scoprisancanziandisonzo.org/cosa-fare?layer=attivita#map-container",
            externalLink_it_piste: "https://scoprisancanziandisonzo.org/cosa-fare?layer=piste#map-container",
            externalLink_it_interessi: "https://scoprisancanziandisonzo.org/cosa-fare?layer=interessi#map-container",

            externalLink_en_attivita: "https://scoprisancanziandisonzo.org/en/what-do?layer=businesses#map-container",
            externalLink_en_piste: "https://scoprisancanziandisonzo.org/en/what-do?layer=cycle-paths#map-container",
            externalLink_en_interessi: "https://scoprisancanziandisonzo.org/en/what-do?layer=points#map-container",

            externalLink_de_attivita: "https://scoprisancanziandisonzo.org/de/was-tun?layer=gewerbe#map-container",
            externalLink_de_piste: "https://scoprisancanziandisonzo.org/de/was-tun?layer=radwege#map-container",
            externalLink_de_interessi: "https://scoprisancanziandisonzo.org/de/was-tun?layer=sehenswurdigkeiten#map-container"


        }
    },
    computed: {
        lang() {
            return this.$store.state.currentLang
        },
        defaultLang() {
            return this.$store.state.defaultLang
        }
    },
    methods: {
        async fetchFooterItems() {
            var menu = []
            var items = []
            var ch = []

            var l = this.lang != this.defaultLang ? ('/' + this.lang) : ''

            await fetch(`${process.env.VUE_APP_ENDPOINT}${l}/jconfig/menu/main`)
                .then(res => res.json())
                .then(json => {
                    items = json.menu.sort((a, b) => {
                        return a.weight > b.weight ? -1 : 1
                    })
                })

            //for each fetched route
            items.forEach((item, index) => {
                ch = []

                //for each menu item with no parent
                //if the number of its children is 0
                if (!item.has_children) {
                    //push it into the menu as a top-level route
                    if (menu[Math.floor(index / this.columnLength)] == undefined)
                        menu[Math.floor(index / this.columnLength)] = []

                    menu[Math.floor(index / this.columnLength)].push({
                        label: item.title,
                        url: item.url
                    })

                } else {
                    item.subtree.forEach(child => ch.push({
                        label: child.title,
                        url: child.url
                    }))

                    //then push them into the menu as a sub-level route (for that corresponding top-level menu)
                    if (menu[Math.floor(index / this.columnLength)] == undefined)
                        menu[Math.floor(index / this.columnLength)] = []

                    menu[Math.floor(index / this.columnLength)].push({
                        label: item.attributes.title,
                        children: ch
                    })
                }
            })
            this.footerItems = menu
        }
    },
    mounted() {
        console.log('THE FOOTER IS MOUNTED')

        this.fetchFooterItems()

    },
    watch: {
        lang() {
            this.fetchFooterItems()
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../styles/variables.scss";



// VUOI SAPERNE DI PIU CONTAINER
.vuoisaperne {
    position: relative;
    width: 100%;
    background-color: #fff;
    margin-bottom: 1rem;

    >img {
        position: relative;
        width: 100%;
    }

    >h6 {
        color: #181923;
        font-size: 16px;
        font-family: "Martel";
        font-weight: 500;
        padding: 0 15px;
        line-height: 24px;
        margin: 0;
        max-width: 60%;
        margin-top: -20px;
    }

    >a {
        display: flex;
        align-items: center;
        text-decoration: none;
        margin: 0 15px;
        border-bottom: 1px solid #dadbde;

        &:last-child {
            border-bottom: 0px solid #dadbde;
        }

        img {
            width: 37px;
        }

        .arrow {
            width: 24px;
            margin-right: 0;
            margin-left: auto;
        }

        h6 {
            text-transform: uppercase;
            font-size: 14px;
            font-family: "Martel";
            font-weight: 600;
            margin: 0;
            padding: 20px 0px;
            margin-left: 15px;
        }
    }

    >a:nth-child(3) {
        h6 {
            color: #C64747;
        }
    }

    >a:nth-child(4) {
        h6 {
            color: #3C465C;
        }
    }

    >a:nth-child(5) {
        h6 {
            color: #BB873C;
        }
    }


}

.social {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 0px;
    padding-bottom: 0;

    a {
        display: inline-block;
        margin: 0px 10px;
    }
}

footer {
    .container {
        padding-left: 15px;
        padding-right: 15px;
        width: auto;
    }

    .logo {
        margin-bottom: 0px;

        img {
            width: 100%;
            height: auto;
        }
    }


    .sitemap {
        background-color: #181923;
        padding: 1rem 0rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .inner-menu {
            margin: 0%;
        }

        .footer-column {
            display: none;
        }

        h4 {
            color: #fff;
            font-weight: 700;
            margin: 0 0 1rem 0;
        }

        a {
            color: #C9CFD9;
            padding: 6px 0px;
            font-size: 0.875rem;
            text-decoration: none;

            &:hover {
                color: $primaryColor;
            }
        }

        p {
            color: #fff;
            font-size: 0.875rem;
        }
    }

    .contacts {
        background-color: #20212E;
        padding: 1rem 0rem 0.5rem 0rem;

        .container {
            display: flex;
            flex-direction: column;

            p {
                color: #929298;
                font-size: 0.875rem;
                margin: .5em 0;
            }

            .infos {
                margin-bottom: 0rem;
                word-break: break-all;
                flex-wrap: wrap;

                p {
                    font-size: 12px;
                }

            }

            .policy {
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #fff;
            }

            .policy ul {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;

                li {
                    padding-left: 0;
                    padding-right: 0;

                    &:before {
                        display: none;
                    }

                    a {
                        text-decoration: none;
                        font-size: 12px;
                    }
                }
            }
        }
    }
}



@media (min-width: 576px) {
    footer {
        p {
            word-break: normal;
        }

        .sitemap .container {
            display: flex;
            flex-direction: column;

            .logo {
                display: flex;
                align-items: center;
            }
        }

        .contacts {
            .container {
                display: flex;
                justify-content: space-between;
                align-items: start;

                .infos {
                    width: 50%;
                }

                .policy {
                    width: 100%;
                }
            }
        }
    }
}

@media (min-width: 768px) {
    .social {
        display: flex;
        justify-content: flex-end;
    }

    footer {
        .container {
            width: 100%;
            flex-direction: row;
            max-width: 600px;
        }

        .contacts {
            .container {
                flex-direction: row;
            }
        }
    }

    footer {
        .contacts {
            .policy {
                width: 50%;

                ul {
                    flex-direction: column;
                    align-items: flex-end;
                }
            }
        }
    }
}

@media (min-width: 992px) {
    footer {
        .container {
            width: 100%;
            flex-direction: row;
            max-width: 900px;
        }
    }
}



</style>